





















import { defineComponent } from '@nuxtjs/composition-api';

export default defineComponent({
  props: {
    stock: {
      type: Number,
      default: 1000,
    },
    thumbnail: {
      type: String,
      required: true,
    },
    name: {
      type: String,
      required: true,
    },
    horizontal: {
      type: Boolean,
      default: false,
    },
    locked: {
      type: Boolean,
      default: false,
    },
  },
  setup() {},
});
